import { JSX } from 'react'

import logo from '../../assets/img/calendar.svg'

export const CalendarIcon = (): JSX.Element => {
  return <img src={logo} height="20" alt="calendar" id="calendarIcon" />
}
